'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable no-underscore-dangle */
/**
 * @file DB core
 * @date 2015-12-29
 * @depends Jquery|Zepto
 * option
 *     {
 *         url: '',
 *         type: 'get',
 *         data: {},
 *         cache: false,
 *         dataType: 'json',
 *         before: function(option) {return option;},
 *         succ: function(data, option) { return false; // 反转至err},
 *         err: function(data, option) {},
 *         'others' // 透传给Jquery|Zepto
 *     }
 * 全局配置
 *     DB.mergeOption(option)
 * 创建请求
 *     var db = new DB(option)
 * 发送请求
 *     db(option)
 * localstorage|bkn|retCode 等请用全局的before|succ|err实现
 */


var _api = require('@opentelemetry/api');

var api = _interopRequireWildcard(_api);

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _fetch = require('./fetch');

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * DB
 * @class
 * @param {Object} option
 */
function DB(option) {
  var self = function self() {
    var _self$_execute;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (_self$_execute = self._execute).call.apply(_self$_execute, [self].concat(args));
  };
  Object.keys(DB.prototype).forEach(function (k) {
    self[k] = DB.prototype[k];
  });
  self.constructor = DB;
  self.option = option || {};
  return self;
}

/**
 * 函数执行
 */
DB.prototype._execute = function () {
  var _ajax;

  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  (_ajax = this.ajax).call.apply(_ajax, [this].concat(args));
};

/**
 * 合并option
 * 类似extend, 不同的是数组做concat操作
 * @param {Object} target
 * @param {..Object} args
 * @return {Object}
 */
function _mergeOption(_target) {
  var target = _target;

  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  args.forEach(function (item) {
    Object.keys(item).forEach(function (k) {
      var value = item[k];
      if (['before', 'succ', 'err'].indexOf(k) !== -1) {
        target[k] = (target[k] || []).concat(_util2.default.isArray(value) ? value : [value]);
      } else {
        target[k] = value;
      }
    });
  });

  return target;
}

var traceParentMetaElement = void 0;
var noTraceParentMetaElement = void 0;
/**
 * ajax
 * @param option
 */
DB.prototype.ajax = function (option) {
  var sender = new Sender(_mergeOption({ succ: [], err: [], before: [] }, DB.option || {}, this.option || {}, option || {}));

  // 此常量本该从 @opentelemetry/core 包导入，但该包会造成 RN 项目构建报错，所以暂时写死
  var TRACE_PARENT_HEADER = 'traceparent';
  // 从 meta 标签中提取链路信息，创建 currentContext
  if (!traceParentMetaElement && !noTraceParentMetaElement) {
    traceParentMetaElement = document.querySelector('meta[name="' + TRACE_PARENT_HEADER + '"]');
    noTraceParentMetaElement = !traceParentMetaElement;
  }
  if (traceParentMetaElement) {
    var _api$propagation$extr;

    var currentContext = api.propagation.extract(api.context.active(), (_api$propagation$extr = {}, _api$propagation$extr[TRACE_PARENT_HEADER] = traceParentMetaElement.content || '', _api$propagation$extr));
    return new Promise(function (resolve) {
      api.context.with(currentContext, function () {
        resolve(sender.send());
      });
    });
  }
  return sender.send();
};

/**
 * 一次请求发送对象
 * before|succ|err 的this指针指向它
 * @class
 * @param {Object} option
 */
function Sender(option) {
  this.option = option || {};
}

Sender.prototype.send = function () {
  var _this = this;

  var option = this.option;

  this.processBefore();
  // 请求发送时间
  this.sendAt = +new Date();

  var complete = function complete(data, xhr) {
    if (option.dataType && option.dataType.toUpperCase() === 'JSONP') {
      if (option.localEnable) {
        _this.responseText = JSON.stringify(data);
      } else {
        _this.responseText = '';
      }
    } else {
      _this.responseText = xhr.responseText;
    }
    _this.response = data;
    _this.processSucc(data);
  };

  (0, _fetch2.default)(_util2.default.extend({}, option, {
    complete: complete
  }));
  if (window.Promise) {
    return new Promise(function (resolve, reject) {
      _this.option.succ.push(resolve);
      _this.option.err.push(reject);
    });
  }
};

/**
 * before ajax
 * before可以返回新的或者直接修改option
 */
Sender.prototype.processBefore = function () {
  // 使用for让外界对before的修改能立即迭代生效
  for (var i = 0; this.option.before && i < this.option.before.length; i++) {
    // 如果要新增before使用before.splice(i, 0, handle)
    this.option = this.option.before[i].call(this, i) || this.option;
  }
};

/**
 * 执行成功
 * succ可以返回false以反转至失败
 * @param {Object} data
 */
Sender.prototype.processSucc = function (_data) {
  var data = _data;
  var succ = true;
  for (var i = 0; this.option.succ && i < this.option.succ.length; i++) {
    var ret = this.option.succ[i].call(this, data, i);
    if (ret === false) {
      succ = false;
      break;
    }
    if ((typeof ret === 'undefined' ? 'undefined' : _typeof(ret)) === 'object') {
      // 修改值
      data = ret;
    }
  }
  !succ && this.processErr(data);
};

/**
 * 执行失败
 * @param {Object} data
 * @param {?Boolean} data.networkError 是否是网络失败
 * @param {?Number} data.status 网络失败时的状态码
 */
Sender.prototype.processErr = function (data) {
  for (var i = 0; this.option.err && i < this.option.err.length; i++) {
    this.option.err[i].call(this, data, i);
  }
};

_util2.default.extend(DB, {
  /**
     * 创建一个DB
     * @deprecated 建议直接使用new DB(option)
     * @param {Object} option
     * @return {DB}
     */
  httpMethod: function httpMethod(option) {
    return new DB(option);
  },


  /**
     * 直接发送ajax 类似$.ajax
     * @param {Object} option
     * @return {Sender}
     */
  ajax: function ajax(option) {
    return new DB()(option);
  },


  /**
     * 扩展自身
     * @param {?Object} args
     */
  extend: function extend() {
    var _$$extend;

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    args.unshift(this);
    return (_$$extend = $.extend).call.apply(_$$extend, [$].concat(args));
  },


  /**
     * 扩展全局设置
     * @param {?Object} args
     */
  mergeOption: function mergeOption() {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    args.unshift(this.option);
    this.option = _mergeOption.call.apply(_mergeOption, [null].concat(args));
  },


  /**
     * 全局设置
     * @type {Object}
     */
  option: {}
});

module.exports = DB;